/**
 * SPR (SpellingRegel) Module Seeds - DDD Canonical Location
 *
 * 22 families, all imports local (./SPR-*.json).
 */

import SPR_KLANK_JAGER from './SPR-KLANK-JAGER.json'
import SPR_KLANK_JAGER_CATEGORIZE from './SPR-KLANK-JAGER-CATEGORIZE.json'
import SPR_KLANK_BAKKER from './SPR-KLANK-BAKKER.json'
import SPR_KLANK_AA_EE_OO from './SPR-KLANK-AA-EE-OO.json'
import SPR_HOOFDLETTER from './SPR-HOOFDLETTER.json'
import SPR_WEET_EI_IJ from './SPR-WEET-EI-IJ.json'
import SPR_WEET_D_T from './SPR-WEET-D-T.json'
import SPR_WEET_D_T_ERROR from './SPR-WEET-D-T-ERROR.json'
import SPR_LEEN_C_S_K from './SPR-LEEN-C-S-K.json'
import SPR_TREMA_MV from './SPR-TREMA-MV.json'
import SPR_LEEN_FRANS from './SPR-LEEN-FRANS.json'
import SPR_SAM_TUSSEN_N from './SPR-SAM-TUSSEN-N.json'
import SPR_LEEN_ENGELS from './SPR-LEEN-ENGELS.json'
import SPR_LEEN_LATIJN from './SPR-LEEN-LATIJN.json'
import SPR_ACCENT from './SPR-ACCENT.json'
import SPR_KLANK_VERDUBBEL from './SPR-KLANK-VERDUBBEL.json'
import SPR_KLANK_VERKORTEN from './SPR-KLANK-VERKORTEN.json'
import SPR_KLANK_AU_OU from './SPR-KLANK-AU-OU.json'
import SPR_WEET_DT from './SPR-WEET-DT.json'
import SPR_LEESTEKEN_PUNT_KOMMA from './SPR-LEESTEKEN-PUNT-KOMMA.json'
import SPR_SAM_TUSSEN_S from './SPR-SAM-TUSSEN-S.json'
import SPR_LEEN_GRIEKS from './SPR-LEEN-GRIEKS.json'
import SPR_WEET_BOUW from './SPR-WEET-BOUW.json'

const SPR_FAMILY_SEEDS = [
  { file: 'src/content/seeds/SPR/SPR-KLANK-JAGER.json', data: SPR_KLANK_JAGER },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-JAGER-CATEGORIZE.json',
    data: SPR_KLANK_JAGER_CATEGORIZE,
  },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-BAKKER.json',
    data: SPR_KLANK_BAKKER,
  },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-AA-EE-OO.json',
    data: SPR_KLANK_AA_EE_OO,
  },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-VERDUBBEL.json',
    data: SPR_KLANK_VERDUBBEL,
  },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-VERKORTEN.json',
    data: SPR_KLANK_VERKORTEN,
  },
  {
    file: 'src/content/seeds/SPR/SPR-KLANK-AU-OU.json',
    data: SPR_KLANK_AU_OU,
  },
  { file: 'src/content/seeds/SPR/SPR-HOOFDLETTER.json', data: SPR_HOOFDLETTER },
  { file: 'src/content/seeds/SPR/SPR-WEET-EI-IJ.json', data: SPR_WEET_EI_IJ },
  { file: 'src/content/seeds/SPR/SPR-WEET-D-T.json', data: SPR_WEET_D_T },
  {
    file: 'src/content/seeds/SPR/SPR-WEET-D-T-ERROR.json',
    data: SPR_WEET_D_T_ERROR,
  },
  { file: 'src/content/seeds/SPR/SPR-WEET-DT.json', data: SPR_WEET_DT },
  { file: 'src/content/seeds/SPR/SPR-LEEN-C-S-K.json', data: SPR_LEEN_C_S_K },
  { file: 'src/content/seeds/SPR/SPR-TREMA-MV.json', data: SPR_TREMA_MV },
  { file: 'src/content/seeds/SPR/SPR-LEEN-FRANS.json', data: SPR_LEEN_FRANS },
  {
    file: 'src/content/seeds/SPR/SPR-SAM-TUSSEN-N.json',
    data: SPR_SAM_TUSSEN_N,
  },
  { file: 'src/content/seeds/SPR/SPR-LEEN-ENGELS.json', data: SPR_LEEN_ENGELS },
  { file: 'src/content/seeds/SPR/SPR-LEEN-LATIJN.json', data: SPR_LEEN_LATIJN },
  { file: 'src/content/seeds/SPR/SPR-ACCENT.json', data: SPR_ACCENT },
  {
    file: 'src/content/seeds/SPR/SPR-LEESTEKEN-PUNT-KOMMA.json',
    data: SPR_LEESTEKEN_PUNT_KOMMA,
  },
  {
    file: 'src/content/seeds/SPR/SPR-SAM-TUSSEN-S.json',
    data: SPR_SAM_TUSSEN_S,
  },
  {
    file: 'src/content/seeds/SPR/SPR-LEEN-GRIEKS.json',
    data: SPR_LEEN_GRIEKS,
  },
  { file: 'src/content/seeds/SPR/SPR-WEET-BOUW.json', data: SPR_WEET_BOUW },
] as const

const allQuestions = SPR_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'SpellingRegel' as const,
  moduleCode: 'SPR',
  version: '5.3-complete',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
